import ajax from '../../utils/ajax';

export default {
    actions: {
        async getFuelCards({commit}, archive = false) {
            const data = await ajax.getFuelCards(Boolean(archive));
            commit(`setFuelCards`, Array.isArray(data) ? data : []);
        },
        async createFuelCard({dispatch}, payload) {
            await ajax.createFuelCard(payload);
            await dispatch(`getFuelCards`);
        },
        async updateFuelCard({dispatch}, {id, payload}) {
            await ajax.updateFuelCard(id, payload);
            await dispatch(`getFuelCards`);
        },
        async archiveFuelCard({dispatch}, id) {
            await ajax.archiveFuelCard(id);
            await dispatch(`getFuelCards`);
        },
        async getFuelCardHistory(_, id) {
            return ajax.getFuelCardHistory(id);
        },
        async getFuelCardAccessSettings({commit}) {
            const data = await ajax.getFuelCardAccessSettings();
            commit(`setAccessSettings`, data);
            return data;
        },
        async updateFuelCardAccessSettings({commit}, accessConfig) {
            const data = await ajax.updateFuelCardAccessSettings(accessConfig);
            commit(`setAccessSettings`, data);
            return data;
        }
    },
    state: {
        items: [],
        accessSettings: {
            access_config: {
                enabled: false,
                read_history_for_readers: false,
                read: {participants: []},
                write: {participants: []}
            },
            can_manage_access: false,
            can_create: false
        }
    },
    mutations: {
        setFuelCards(state, value) {
            state.items = value;
        },
        setAccessSettings(state, value) {
            state.accessSettings = value;
        }
    }
}
